export const basketballRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '94\' × 50\''
    },
    points: [
      'NBA court: 94 feet long × 50 feet wide',
      'High school court: 84 feet long × 50 feet wide',
      'Three-point line: 23.75 feet (NBA), 22.15 feet (college)',
      'Free throw line: 15 feet from backboard'
    ],
    keyFact: 'The three-point line distance has changed multiple times in NBA history!'
  },
  {
    title: 'Team Composition',
    type: 'info',
    diagram: {
      label: 'Players per Team',
      value: '5'
    },
    points: [
      '5 players per team on court',
      'Unlimited substitutions during stoppages',
      'Typically 12-15 players on roster',
      'Positions: Point Guard, Shooting Guard, Small Forward, Power Forward, Center'
    ],
    keyFact: 'Basketball is one of the few sports where substitutions can happen multiple times per game!'
  },
  {
    title: 'Game Duration',
    type: 'info',
    diagram: {
      label: 'Game Length',
      value: '48 minutes'
    },
    points: [
      'NBA: Four 12-minute quarters',
      'College: Two 20-minute halves',
      'High school: Four 8-minute quarters',
      'Overtime: 5 minutes if tied'
    ],
    keyFact: 'The longest NBA game ever went into 6 overtimes, lasting 78 minutes of play time!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Points',
      value: '1-2-3'
    },
    points: [
      'Field goal: 2 points',
      'Three-pointer: 3 points (beyond arc)',
      'Free throw: 1 point',
      'Team with most points wins'
    ],
    keyFact: 'The three-point shot was not adopted by the NBA until 1979!'
  },
  {
    title: 'Traveling Violation',
    type: 'dont',
    points: [
      'Cannot take more than two steps without dribbling',
      'Must dribble while moving with the ball',
      'Pivot foot must remain planted when not dribbling',
      'Cannot dribble, stop, then dribble again (double dribble)'
    ],
    keyFact: 'The "gather step" rule allows players to take two steps after picking up their dribble!'
  },
  {
    title: 'Shot Clock',
    type: 'info',
    diagram: {
      label: 'Time to Shoot',
      value: '24 seconds'
    },
    points: [
      'NBA/FIBA: 24 seconds to attempt a shot',
      'College (men): 30 seconds',
      'College (women): 30 seconds',
      'High school: varies by state (30-35 seconds)'
    ],
    keyFact: 'The shot clock was introduced in 1954 to speed up the game and prevent stalling!'
  }
];

export const basketballGoverningBodies = [
  {
    name: 'FIBA',
    description: 'International Basketball Federation - Global governing body for basketball with 213 national federations. Organizes World Cup and Olympic basketball.',
    website: 'https://www.fiba.basketball'
  },
  {
    name: 'NBA',
    description: 'National Basketball Association - Premier professional basketball league in North America with 30 teams. Sets standards followed worldwide.',
    website: 'https://www.nba.com'
  },
  {
    name: 'USA Basketball',
    description: 'National governing body for basketball in the United States, overseeing national teams, youth development, and amateur basketball.',
    website: 'https://www.usab.com'
  }
];

export const basketballTournaments = [
  {
    name: 'NBA Finals',
    description: 'Championship series of the National Basketball Association, featuring the Eastern and Western Conference champions in a best-of-7 series.',
    website: 'https://www.nba.com/finals'
  },
  {
    name: 'FIBA Basketball World Cup',
    description: 'International tournament held every 4 years featuring 32 national teams competing for the world championship.',
    website: 'https://www.fiba.basketball/basketballworldcup'
  },
  {
    name: 'NCAA March Madness',
    description: 'Annual single-elimination tournament featuring 68 college teams competing for the national championship.',
    website: 'https://www.ncaa.com/march-madness'
  },
  {
    name: 'Olympic Basketball',
    description: 'Basketball competition at the Summer Olympics featuring 12 men\'s and 12 women\'s national teams.',
    website: 'https://www.fiba.basketball/olympics'
  }
];

export const basketballResources = [
  {
    name: 'USA Basketball Events',
    website: 'https://www.usab.com/events'
  },
  {
    name: 'NBA Schedule',
    website: 'https://www.nba.com/schedule'
  },
  {
    name: 'FIBA Rankings',
    website: 'https://www.fiba.basketball/rankingmen'
  }
];
